import { createFileRoute } from '@tanstack/react-router';
import { UnauthorizedPage } from '@/components/unauthorized-page';

export const Route = createFileRoute('/unauthorized')({
  component: UnauthorizedPage,
});
